module.exports = __webpack_public_path__ + "static/media/icon-link.079d042a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-link.svg
// module id = 1566
// module chunks = 0